import { FC } from 'react';
import SearchForm, { SearchFormProps } from './searchForm';
import SearchFormGroup, { SearchFormGroupProps } from './group';
import SearchFormInput, { SearchFormInputProps } from './input';
import SearchFormButton, { SearchFormButtonProps } from './button';
import SearchFormSwitch, { SearchFormSwitchProps } from './switchCopy';
import SearchFormInputNumber, {
  SearchFormInputNumberProps,
} from './inputNumber';
import SearchFormSelect, { SearchFormSelectProps } from './select';
import SearchFormSelectTab, { SearchFormSelectTabProps } from './selectTab';
import SearchFormSuperSelect, { SearchFormSuperSelectProps } from './superSelect';
import SearchFormSelectInput, {
  SearchFormSelectInputProps,
} from './selectInput';
import SearchFormSelectTable, {
  SearchFormSelectTableProps,
} from './selectTable';
import SearchFormSuperSelectTable, {
  SearchFormSuperSelectTableProps,
} from './superSelectTable';
import SearchFormOperation, { SearchFormOperationProps } from './operation';
import SearchFormTabs, { SearchFormTabsProps } from './tabs';
import SearchFormTextArea, { SearchFormTextAreaProps } from './textArea';
import SearchFormOther, { SearchFormOtherProps } from './other';
import SearchFormDatePicker, { SearchFormDatePickerProps } from './datePicker';
import SearchFormRangePicker, {
  SearchFormRangePickerProps,
} from './rangePicker';
import SearchFormTimePicker, { SearchFormTimePickerProps } from './timePicker';
import SearchFormUpload, { SearchFormUploadProps } from './upload';
import SearchFormUploadImage, {
  SearchFormUploadImageProps,
} from './uploadImage';
import SearchFormUploadImages, {
  SearchFormUploadImagesProps,
} from './uploadImages';
import SearchFormCustomItem, { SearchFormCustomItemProps } from './customItem';
import SearchFormFixed, { SearchFormFixedProps } from './fixed';
import SearchFormInputSelect, {
  SearchFormInputSelectProps,
} from './inputSelect';
import SearchFormInputInterval, {
  SearchFormInputIntervalProps,
} from './inputInterval';
import SearchFormCheckbox, { SearchFormCheckboxProps } from './checkbox';
import SearchFormCheckboxGroup, {
  SearchFormCheckboxGroupProps,
} from './checkboxGroup';
import SearchFormCombination, {
  SearchFormCombinationProps,
} from './combination';
import SearchFormTreeSelect, { SearchFormTreeSelectProps } from './treeSelect';
import SearchFormAssociateSelect, {
  SearchFormAssociateSelectProps,
} from './associateSelect';
import SearchFormAutoMatch, { SearchFormAutoMatchProps } from './autoMatch';
import SearchFormRadioGroup, { SearchFormRadioGroupProps } from './radioGroup';
import SearchFormSelectGroup, {
  SearchFormSelectGroupProps,
} from './selectGroup';
import SearchFormTextAreaRow, {
  SearchFormTextAreaRowProps,
} from './textAreaRow';
import SearchFormTimeSlot, { SearchFormTimeSlotProps } from './timeSlot';
import SearchFormSelectCustom, {
  SearchFormSelectCustomProps,
} from './selectCustom';
import SearchFormZoneTime, { SearchFormZoneTimeProps } from './zoneTime';
import SearchFormSelectGroupTable, { SearchFormSelectGroupTableProps } from './selectGroupTable';
import SearchFormCascader, { SearchFormCascaderProps } from './cascader';
import SearchFormScanInput, { SearchFormScanInputProps } from './scanInput';
import SearchFormAutoComplete, { SearchFormAutoCompleteProps } from './autoComplete';
import SearchFormLine, { SearchFormLineProps } from './line';
import SearchFormUploadAvatar, { SearchFormUploadAvatarProps } from './uploadAvatar';
import SearchFormGroupSearch, { SearchFormGroupSearchProps } from './groupSearch';
import SearchFormRows, { SearchFormRowsProps } from './rows';
import SearchFormIntervalType, { SearchFormIntervalTypeProps } from './intervalType';
import SearchFormNumberInterval, { SearchFormNumberIntervalProps } from './numberInterval';
import SearchFormDropdownTable, { SearchFormDropdownTableProps } from './dropdownTable';
import SearchFormDropdownSyncTable, { SearchFormDropdownSyncTableProps } from './dropdownSyncTable';
import SearchFormCardForm, { SearchFormCardFormProps } from './cardForm';
import SearchFormFieldGroupSearch, { SearchFormFieldGroupSearchProps } from './fieldGroupSearch';
import SearchFormSuperTransfer, { SearchFormSuperTransferProps } from './superTransfer';
import SearchFormDateRange, { SearchFormDateRangeProps } from './dateRange';
import SearchFormSuperAutoComplete, { SearchFormSuperAutoCompleteProps } from './superAutoComplete';

// @ts-ignore
export interface SearchFormItemProps
  extends SearchFormGroupProps,
    SearchFormInputProps,
    SearchFormButtonProps,
    SearchFormSwitchProps,
    SearchFormInputNumberProps,
    SearchFormSelectProps,
    SearchFormSelectInputProps,
    SearchFormSelectTableProps,
    SearchFormOperationProps,
    SearchFormTabsProps,
    SearchFormTextAreaProps,
    SearchFormOtherProps,
    SearchFormDatePickerProps,
    SearchFormRangePickerProps,
    SearchFormTimePickerProps,
    SearchFormUploadProps,
    SearchFormUploadImageProps,
    SearchFormUploadImagesProps,
    SearchFormCustomItemProps,
    SearchFormFixedProps,
    SearchFormInputSelectProps,
    SearchFormSelectTabProps,
    SearchFormInputIntervalProps,
    SearchFormCheckboxProps,
    SearchFormCheckboxGroupProps,
    SearchFormCombinationProps,
    SearchFormTreeSelectProps,
    SearchFormAssociateSelectProps,
    SearchFormRadioGroupProps,
    SearchFormSelectGroupProps,
    SearchFormTextAreaRowProps,
    SearchFormTimeSlotProps,
    SearchFormSelectCustomProps,
    SearchFormZoneTimeProps,
    SearchFormSelectGroupTableProps,
    SearchFormCascaderProps,
    SearchFormScanInputProps,
    SearchFormAutoCompleteProps,
    SearchFormLineProps,
    SearchFormUploadAvatarProps,
    SearchFormSuperSelectProps,
    SearchFormSuperSelectTableProps,
    SearchFormAutoMatchProps,
    SearchFormGroupSearchProps,
    SearchFormRowsProps,
    SearchFormIntervalTypeProps,
    SearchFormNumberIntervalProps,
    SearchFormDropdownTableProps,
    SearchFormDropdownSyncTableProps,
    SearchFormCardFormProps,
    SearchFormFieldGroupSearchProps,
    SearchFormSuperTransferProps,
    SearchFormDateRangeProps,
    SearchFormSuperAutoCompleteProps {}
export type ISearchFormComponent = FC<SearchFormProps> & {
  /** 分组 */
  Group: FC<SearchFormGroupProps>;
  /** 普通输入框 */
  Input: FC<SearchFormInputProps>;
  /** 按钮 */
  Button: FC<SearchFormButtonProps>;
  /** 单选按钮 */
  Switch: FC<SearchFormSwitchProps>;
  /** 数字输入框 */
  InputNumber: FC<SearchFormInputNumberProps>;
  /** 输入框+下拉框 */
  InputSelect: FC<SearchFormInputSelectProps>;
  /** 下拉 */
  Select: FC<SearchFormSelectProps>;
  /** 分tabs下拉选择框 */
  SelectTab: FC<SearchFormSelectTabProps>;
  /** 非antd下拉 */
  SuperSelect: FC<SearchFormSuperSelectProps>;
  /** 下拉+文本框组合 */
  SelectInput: FC<SearchFormSelectInputProps>;
  /** 下拉表格 */
  SelectTable: FC<SearchFormSelectTableProps>;
  /** 基于SuperSelect的下拉表格 */
  SuperSelectTable: FC<SearchFormSuperSelectTableProps>;
  /** 操作按钮 */
  Operation: FC<SearchFormOperationProps>;
  /** 标签页 */
  Tabs: FC<SearchFormTabsProps>;
  /** 标签页 */
  TextArea: FC<SearchFormTextAreaProps>;
  /** 其他表单 */
  Other: FC<SearchFormOtherProps>;
  /** 日期时间表单 */
  DatePicker: FC<SearchFormDatePickerProps>;
  /** 日期时间区间 */
  RangePicker: FC<SearchFormRangePickerProps>;
  /** 时间 */
  TimePicker: FC<SearchFormTimePickerProps>;
  /** 上传 */
  Upload: FC<SearchFormUploadProps>;
  /** 上传图片 */
  UploadImage: FC<SearchFormUploadImageProps>;
  /** 上传多张图片 */
  UploadImages: FC<SearchFormUploadImagesProps>;
  /** 自定义表单 */
  CustomItem: FC<SearchFormCustomItemProps>;
  /** 左右fixed布局 */
  Fixed: FC<SearchFormFixedProps>;
  /** 数字区间 */
  InputInterval: FC<SearchFormInputIntervalProps>;
  /** 选择框 */
  Checkbox: FC<SearchFormCheckboxProps>;
  /** 多选框 */
  CheckboxGroup: FC<SearchFormCheckboxGroupProps>;
  /** 多个 Input/InputNumber/CustomItem 组合 */
  Combination: FC<SearchFormCombinationProps>;
  /** 下拉树 */
  TreeSelect: FC<SearchFormTreeSelectProps>;
  /** 下拉匹配 */
  AssociateSelect: FC<SearchFormAssociateSelectProps>;
  /** 下拉匹配 */
  AutoMatch: FC<SearchFormAutoMatchProps>;
  /** 单选按钮组 */
  RadioGroup: FC<SearchFormRadioGroupProps>;
  /** 分组下拉 */
  SelectGroup: FC<SearchFormSelectGroupProps>;
  /** 多行文本 */
  TextAreaRow: FC<SearchFormTextAreaRowProps>;
  /** 日期时间组合 */
  TimeSlot: FC<SearchFormTimeSlotProps>;
  /** 下拉列表+自定义表单 */
  SelectCustom: FC<SearchFormSelectCustomProps>;
  /** 时区+时间类型+时间 */
  ZoneTime: FC<SearchFormZoneTimeProps>;
  /** 下拉分组+下拉列表组合 */
  SelectGroupTable: FC<SearchFormSelectGroupTableProps>;
  /** 下拉分类 */
  Cascader: FC<SearchFormCascaderProps>;
  /** 条码输入 */
  ScanInput: FC<SearchFormScanInputProps>;
  /** 自动输入 */
  AutoComplete: FC<SearchFormAutoCompleteProps>;
  /** 分割线 */
  Line: FC<SearchFormLineProps>;
  /** 上传图片（base64） */
  UploadAvatar: FC<SearchFormUploadAvatarProps>;
  /** 下拉+匹配类型+多行输入框 组合搜索 */
  GroupSearch: FC<SearchFormGroupSearchProps>;
  /** 多行表单组合 */
  Rows: FC<SearchFormRowsProps>;
  /** 类型+区间 */
  IntervalType: FC<SearchFormIntervalTypeProps>;
  /** 数字区间 */
  NumberInterval: FC<SearchFormNumberIntervalProps>;
  /** 下拉表格 */
  DropdownTable: FC<SearchFormDropdownTableProps>;
  /** 异步下拉表格 */
  DropdownSyncTable: FC<SearchFormDropdownSyncTableProps>;
  /** 卡片表单 */
  CardForm: FC<SearchFormCardFormProps>;
  /** 组合搜索 */
  FieldGroupSearch: FC<SearchFormFieldGroupSearchProps>;
  /** 穿梭表单 */
  SuperTransfer: FC<SearchFormSuperTransferProps>;
  /** 时间段 */
  DateRange: FC<SearchFormDateRangeProps>;
  /** 自动搜索+可输入 */
  SuperAutoComplete: FC<SearchFormSuperAutoCompleteProps>;
};
/** 表单 */
const TransSearchForm = SearchForm as ISearchFormComponent;
TransSearchForm.Group = SearchFormGroup;
TransSearchForm.Input = SearchFormInput;
TransSearchForm.Button = SearchFormButton;
TransSearchForm.Switch = SearchFormSwitch;
TransSearchForm.InputNumber = SearchFormInputNumber;
TransSearchForm.Select = SearchFormSelect;
TransSearchForm.SelectTab = SearchFormSelectTab;
TransSearchForm.SuperSelect = SearchFormSuperSelect;
TransSearchForm.SelectInput = SearchFormSelectInput;
TransSearchForm.SelectTable = SearchFormSelectTable;
TransSearchForm.SuperSelectTable = SearchFormSuperSelectTable
TransSearchForm.Operation = SearchFormOperation;
TransSearchForm.Tabs = SearchFormTabs;
TransSearchForm.TextArea = SearchFormTextArea;
TransSearchForm.Other = SearchFormOther;
TransSearchForm.DatePicker = SearchFormDatePicker;
TransSearchForm.RangePicker = SearchFormRangePicker;
TransSearchForm.TimePicker = SearchFormTimePicker;
TransSearchForm.Upload = SearchFormUpload;
TransSearchForm.UploadImage = SearchFormUploadImage;
TransSearchForm.UploadImages = SearchFormUploadImages;
TransSearchForm.CustomItem = SearchFormCustomItem;
TransSearchForm.Fixed = SearchFormFixed;
TransSearchForm.InputSelect = SearchFormInputSelect;
TransSearchForm.InputInterval = SearchFormInputInterval;
TransSearchForm.CheckboxGroup = SearchFormCheckboxGroup;
TransSearchForm.Combination = SearchFormCombination;
TransSearchForm.TreeSelect = SearchFormTreeSelect;
TransSearchForm.AssociateSelect = SearchFormAssociateSelect;
TransSearchForm.AutoMatch = SearchFormAutoMatch;
TransSearchForm.Checkbox = SearchFormCheckbox;
TransSearchForm.RadioGroup = SearchFormRadioGroup;
TransSearchForm.SelectGroup = SearchFormSelectGroup;
TransSearchForm.TextAreaRow = SearchFormTextAreaRow;
TransSearchForm.TimeSlot = SearchFormTimeSlot;
TransSearchForm.SelectCustom = SearchFormSelectCustom;
TransSearchForm.ZoneTime = SearchFormZoneTime;
TransSearchForm.SelectGroupTable = SearchFormSelectGroupTable;
TransSearchForm.Cascader = SearchFormCascader;
TransSearchForm.ScanInput = SearchFormScanInput;
TransSearchForm.AutoComplete = SearchFormAutoComplete;
TransSearchForm.Line = SearchFormLine;
TransSearchForm.UploadAvatar = SearchFormUploadAvatar;
TransSearchForm.GroupSearch = SearchFormGroupSearch;
TransSearchForm.Rows = SearchFormRows;
TransSearchForm.IntervalType = SearchFormIntervalType;
TransSearchForm.NumberInterval = SearchFormNumberInterval;
TransSearchForm.DropdownTable = SearchFormDropdownTable;
TransSearchForm.DropdownSyncTable = SearchFormDropdownSyncTable;
TransSearchForm.CardForm = SearchFormCardForm;
TransSearchForm.FieldGroupSearch = SearchFormFieldGroupSearch;
TransSearchForm.SuperTransfer = SearchFormSuperTransfer;
TransSearchForm.DateRange = SearchFormDateRange;
TransSearchForm.SuperAutoComplete = SearchFormSuperAutoComplete;

export default TransSearchForm;
